import { PersonLocation } from '@aibees/elephant/feature/search-table-people';
import { Nullable } from '@aibees/shared/definition';
import { capitalize } from '@aibees/shared/utils';

export function humanReadablePersonLocation(
  location: Nullable<PersonLocation>
) {
  let response = '';
  if (location?.country) {
    response += capitalize(location?.country);
  }
  if (location?.state) {
    if (location?.country) response += ', ';
    response += capitalize(location?.state);
  }
  if (location?.city) {
    if (location?.country || location?.state) response += ', ';
    response += capitalize(location?.city);
  }
  return response;
}
